import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { getPartnerDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Editpartner = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [profile_pic_name, setProfile_pic_name] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [countryId, setCountryID] = useState("");
  const id = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const partnerView = useSelector((state) => state.partnerView);
  const { partner } = partnerView;

  let token = localStorage.getItem("accessToken");

  useEffect(() => {
    dispatch(getPartnerDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (partner?.data?.profile_pic !== null) {
      setFile({
        files: partner?.data?.profile_pic,
        preview: partner?.data?.profile_pic,
      });
    } else {
      setFile({
        files: "",
        preview:
          "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
      });
    }
  }, [partner]);

  useEffect(() => {
    if (partner) {
      setValue("title", partner?.data?.title);
      setValue("about_partners", partner?.data?.about_partners);
      setValue("description", partner?.data?.description);
      setProfile_pic_name(partner?.data?.profile_pic);
      setCountryID(partner?.data?.country_id);
    }
  }, [partner]);

  const handleCountry = (e) => {
    const getCounryId = e.target.value;
    setCountryID(getCounryId);
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API + "get-country")
      .then((res) => setData(res.data.data))
      .catch((err) => console.log(err));
  }, []);

  const countries = [...new Set(data)];
  countries.sort();

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = async (e) => {
    const baseUrl = process.env.REACT_APP_API + "admin/update-userprofilepic";
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let formData = new FormData();
      setLoading(true);
      formData.append("user_id", id.partnerId);
      formData.append("file", selected);
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      };
      const res = await axios
        .patch(baseUrl, formData, axiosConfig)
        .then((response) => {
          setFile({
            files: response?.data?.data?.document_name,
            preview: response?.data?.data?.document_name,
          });
          setLoading(false);
          setError(false);
        });
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (partnerView) {
      if (partnerView?.loading !== undefined) {
        setLoading(partnerView?.loading);
      }
    }
  }, [partnerView]);

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("id", id.partnerId);
    formData.append("file", file?.files);
    formData.append("profile_pic_name", profile_pic_name);
    formData.append("countryId", countryId);

    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "update-our-partners",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/our-partners");
      }
    } catch (error) {
      if (error.response !== "" && error.response.data.message !== "") {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit New Partner</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : partner?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  {...register("title", {
                    required: "Title is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Title"
                />
                {errors.title && (
                  <div className="invalid-feedback">{errors.title.message}</div>
                )}
              </div>
              <div className="formInput">
                <label>About Partner</label>
                <input
                  type="text"
                  name="about_partners"
                  {...register("about_partners", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.about_partners && (
                  <div className="invalid-feedback">
                    {errors.about_partners.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <select
                  name="countryPartner"
                  className="sort-by dropdown"
                  onChange={(e) => handleCountry(e)}
                  value={countryId}
                >
                  <option value="11" disabled selected hidden>
                    Italy
                  </option>
                  {countries.map((items) => (
                    <option key={items.id} value={items.id}>
                      {items.country_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formInput">
                <label>Description</label>

                <textarea
                  type="text"
                  name="description"
                  className="description-textarea"
                  {...register("description", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.description && (
                  <div className="invalid-feedback text-left">
                    {errors.description.message}
                  </div>
                )}
              </div>
              <div className="formInput"></div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editpartner;
